import { AxiosInstance } from 'axios';

import { BaseAuthenticatedClient } from '.';
import { BaseDataResponse, BaseResponse } from '../responses';
import { ReservationGuestCheckOutModel } from '../interfaces';
import { IAuthenticatedRequestHandler, IErrorHandler } from '../abstractions';

export default class ReservationGuestCheckOutClient extends BaseAuthenticatedClient {
  constructor(authenticatedRequestHandler: IAuthenticatedRequestHandler, errorHandler: IErrorHandler, axiosInstance: AxiosInstance) {
    super(authenticatedRequestHandler, errorHandler, axiosInstance, 'reservationguestcheckout');
  }

  public async getAllAsync(id: number): Promise<BaseDataResponse<ReservationGuestCheckOutModel[]>> {
    return await this.getHttpAsync<BaseDataResponse<ReservationGuestCheckOutModel[]>>(`${id}`, '');
  }

  public async createAsync(model: ReservationGuestCheckOutModel): Promise<BaseDataResponse<ReservationGuestCheckOutModel>> {
    return await this.postHttpAsync<BaseDataResponse<ReservationGuestCheckOutModel>, ReservationGuestCheckOutModel>('', model);
  }

  public async updateAsync(model: ReservationGuestCheckOutModel): Promise<BaseDataResponse<ReservationGuestCheckOutModel>> {
    return await this.putHttpAsync<BaseDataResponse<ReservationGuestCheckOutModel>, ReservationGuestCheckOutModel>(`${model.id}`, model);
  }

  public async deleteAsync(id: number): Promise<BaseResponse> {
    return await this.deleteHttpAsync<BaseResponse>(`${id}`);
  }

  public async getInfoAsync(model: ReservationGuestCheckOutModel): Promise<BaseDataResponse<string>> {
    return await this.postHttpAsync<BaseDataResponse<string>, ReservationGuestCheckOutModel>('info', model);
  }
}
